/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Calc_LeadInputs */

const en_mk_calc_lead = /** @type {(inputs: Mk_Calc_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag the number of people. The comparison figures are public list prices per seat from each product’s own pricing page — not estimates, and the sources are noted below.`)
};

const id_mk_calc_lead = /** @type {(inputs: Mk_Calc_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geser jumlah anggota tim. Angka pembanding adalah harga daftar publik per kursi dari halaman harga masing-masing produk — bukan tebakan, dan sumbernya tercantum di bawah.`)
};

/**
* | output |
* | --- |
* | "Drag the number of people. The comparison figures are public list prices per seat from each product’s own pricing page — not estimates, and the sources are n..." |
*
* @param {Mk_Calc_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_calc_lead = /** @type {((inputs?: Mk_Calc_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Calc_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_calc_lead(inputs)
	return en_mk_calc_lead(inputs)
});